import { createReducer, on } from "@ngrx/store";
import { User } from "../../schemas/user";
import { addUser } from "../actions/user.action";

const initialState: User = {
  fullname: "",
  email: "",
}
export const userReducer = createReducer(
  initialState,
  on(addUser, (_, action) => (action.payload))
);